import roleValidationErrorTemplate from './roleValidationError.tpl.html';

export default {
    templateUrl: roleValidationErrorTemplate,
};
